export const DEFAULT_VALUE = {
    netError: {
        imgUrl: 'https://s.qunarzz.com/q_design_font/images/netError.png',
        text: '哎呀，网络连接出现问题\n请检查一下网络吧～',
        showButton: true,
        buttonText: '重试'
    },
    noResult: {
        imgUrl: 'https://s.qunarzz.com/q_design_font/images/noResult.png',
        text: '没有搜索记录呦～'
    },
    noData: {
        imgUrl: 'https://s.qunarzz.com/q_design_font/images/dataFail.png',
        text: '数据加载失败，请重新加载',
        showButton: true,
        buttonText: '重试'
    },
    emptyData: {
        imgUrl: 'https://s.qunarzz.com/q_design_font/images/empty.png',
        text: '您还没有订单呦～'
    },
    '': {}
};
